import { createInertiaApp } from '@inertiajs/react'
// Vite resolves this cache-busting query at runtime.
// @ts-expect-error Vite query imports are not represented in the TypeScript module map.
import Home from '../pages/home/index?ux=2'

const pages = { 'home/index': Home }

void createInertiaApp({
  resolve: (name) => pages[name as keyof typeof pages],

  strictMode: true,

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions: () => {
      return { queryStringArrayFormat: "brackets" }
    },
  },
}).catch((error) => {
  // This ensures this entrypoint is only loaded on Inertia pages
  // by checking for the presence of the root element (#app by default).
  // Feel free to remove this `catch` if you don't need it.
  if (document.getElementById("app")) {
    throw error
  } else {
    console.error(
      "Missing root element.\n\n" +
      "If you see this error, it probably means you loaded Inertia.js on non-Inertia pages.\n" +
      'Consider moving <%= vite_typescript_tag "inertia.tsx" %> to the Inertia-specific layout instead.',
    )
  }
})
